module.exports = __webpack_public_path__ + "img/microchip-ai.9489d5ad.svg";